import isCacheEmpty from 'owa-recipient-cache/lib/utils/isCacheEmpty';
import { FindRecipientInfoType } from 'owa-recipient-common/lib/components/FindRecipientInfo';
import FindControlViewState from 'owa-recipient-common/lib/store/schema/FindControlViewState';
import { isStringNullOrWhiteSpace } from 'owa-strings';
import isValidEmailAddress from 'owa-readwrite-recipient-well/lib/utils/isValidEmailAddress';
import { isFeatureEnabled } from 'owa-feature-flags';
import { isUnbound } from 'owa-linkedin';
import isLinkedInButtonDismissed from './isLinkedInButtonDismissed';

export default function shouldShowHeaderFooterItem(
    infoType: FindRecipientInfoType,
    viewState: FindControlViewState
): () => boolean {
    return function(): boolean {
        switch (infoType) {
            case FindRecipientInfoType.Searching:
                return hasQueryString(viewState) && viewState.isSearching;
            case FindRecipientInfoType.TypeToSearch:
                return !hasQueryString(viewState) && isCacheEmpty();
            case FindRecipientInfoType.SearchDirectory:
                return (
                    hasQueryString(viewState) &&
                    !viewState.isSearching &&
                    !viewState.hasSearchedDirectory
                );
            case FindRecipientInfoType.TopNResults:
                return hasQueryString(viewState) && viewState.hasSearchedDirectory;
            case FindRecipientInfoType.UseAddress:
                return (
                    hasQueryString(viewState) &&
                    viewState.hasSearchedDirectory &&
                    viewState.findResultSet.length == 0 &&
                    isValidEmailAddress(viewState.queryString)
                );
            case FindRecipientInfoType.SuggestedContacts:
                return !hasQueryString(viewState) && viewState.findResultSet.length > 0;
            case FindRecipientInfoType.FindPeopleFeedback:
                return (
                    isFeatureEnabled('rp-findPeopleSuggestionFeedback') &&
                    isFeatureEnabled('rp-3SPeopleSuggestions')
                );
            case FindRecipientInfoType.LinkedInAccountBind:
                return (
                    isFeatureEnabled('rp-linkedInPeopleSuggestions') &&
                    isFeatureEnabled('rp-showLinkedInBindingBtnInPeoplePicker') &&
                    isUnbound() &&
                    !isLinkedInButtonDismissed()
                );
            default:
                return false;
        }
    };
}

let hasQueryString = (viewState: FindControlViewState) => {
    return !isStringNullOrWhiteSpace(viewState.queryString);
};
